import { render, staticRenderFns } from "./card-style-picto.vue?vue&type=template&id=05844142"
import script from "./card-style-picto.vue?vue&type=script&lang=js"
export * from "./card-style-picto.vue?vue&type=script&lang=js"
import style0 from "./card-style-picto.vue?vue&type=style&index=0&id=05844142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports